<template>
	<div>
		<div :class="'sr-widget_'+matchId"></div>
	</div>
</template>

<script>
    export default {
        name: "scoreboard",
	    props: {
            matchId: {
                default: 0
            },
		    collapseTo: {
                type: String,
			    default: 'disable'
		    },
            layout: {
                type: String,
                default: 'single'
            },
	    },
	    watch: {
            'matchId' () {
                this.sportWidget()
            }
	    },
	    destroy () {
            this.matchId = null;
            SIR = null;
	    },
	    mounted () {

            (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
                    g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
            )})(window,document,"script", "/static/sir/widgetloader.js", "SIR", {
                theme: false, // using custom theme
                language: 'tr'
            });

            this.sportWidget()

	    },
	    methods:{
            sportWidget(){
                SIR("addWidget", ".sr-widget_"+this.matchId, "match.lmtPlus", {showOdds:false,adsFrequency:false,collapseTo: this.collapseTo,layout: this.layout, detailedScoreboard: "enable", language: window.userLang, matchId: this.matchId});
            }
	    }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/stats/widget/scoreboard.vue